import { useLayoutEffect } from "react"

export function useLayoutEffectTimeout( handler: () => void, timeout: number ) {
  useLayoutEffect( () => {
    const timer = setTimeout( handler, timeout )
    return () => clearTimeout( timer )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )
}
